import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ProductsService from "@services/ProductsService";

export const getEditProduct = createAsyncThunk(
  "product/edit",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ProductsService.viewProduct({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const updateProduct = createAsyncThunk(
  "product/update",
  async ({id, product}, {rejectWithValue}) => {
    try {
      const response = await ProductsService.updateProduct({id, product});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  target: null,
  initialTarget: null,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const editProductSlice = createSlice({
  name: "edit-product",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearEdit() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEditProduct.pending, (state) => {
        pendingState(state);
      })
      .addCase(getEditProduct.fulfilled, (state, action) => {
        state.target = action.payload;
        state.initialTarget = action.payload;
        fulfilledState(state);
      })
      .addCase(getEditProduct.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(updateProduct.pending, (state) => {
        pendingState(state);
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.target = action.payload;
        state.initialTarget = action.payload;
        fulfilledState(state);
      })
      .addCase(updateProduct.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setIsChanged, setTarget, setError, setStatus, clearEdit} =
  editProductSlice.actions;
export default editProductSlice.reducer;
